module.exports = __webpack_public_path__ + "static/media/user1.0ff6ac68.png";